<template>
  <div class="formula-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="公式名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入公式名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="收费类型" prop="type">
        <a-select :disabled="isDefault" v-model="form.type" placeholder="请选择收费类型">
          <a-select-option :value="value.id" v-for="value in typeOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="配置公式" prop="content">
        <div class="wrap">
          <div class="top">
            <a-row :gutter="[32, 0]" type="flex" align="middle">
              <template v-for="value in formulaOptions.filter(val => val.type)">
                <a-col :key="value.type" v-if="value.type === 'input'">
                  <a-input v-model="value.value" placeholder="请输入自定义数字" allow-clear v-if="value.type === 'input'" @pressEnter="addContent(value)">
                    <a-icon type="plus" slot="addonAfter" @click="addContent(value)"></a-icon>
                  </a-input>
                </a-col>
                <a-col :key="value.type" @click="addContent(value)" v-else>
                  <span>{{value.value}}</span>
                </a-col>
              </template>
              <a-col>
                <a-dropdown>
                  <span>变量<a-icon type="down"></a-icon></span>
                  <a-menu slot="overlay">
                    <a-menu-item v-for="value in formulaOptions.filter(val => val.name)" :key="value.name" @click="addContent(value)">{{value.name}}</a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-col>
            </a-row>
          </div>
          <div class="bottom">
            <a-tag closable v-for="(value, index) in form.content" :key="index" @close.prevent="deleteContent(index)">{{value.name || value.value}}</a-tag>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="note">
        <a-textarea v-model="form.note" placeholder="请输入备注"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import ChargeTypeService from '@/io/charge_type.js';
  import FormulaService from '@/io/formula.js';

  export default {
    name: 'FormulaInfo',
    data() {
      return {
        id: this.$route.params.id,
        isDefault: false, // 默认数据不可编辑
        typeOptions: [],
        formulaOptions: [
          {
            value: '+',
            type: '+'
          },
          {
            value: '-',
            type: '-'
          },
          {
            value: '*',
            type: '*'
          },
          {
            value: '/',
            type: '/'
          },
          {
            value: '(',
            type: '('
          },
          {
            value: ')',
            type: ')'
          },
          {
            value: null,
            type: 'input'
          },
          {
            name: '单价',
            value: 'price'
          },
          {
            name: '建筑面积',
            value: 'buildArea'
          },
          {
            name: '使用面积',
            value: 'useArea'
          },
          {
            name: '公共面积',
            value: 'publicArea'
          },
          {
            name: '赠送面积',
            value: 'giftArea'
          },
        ],
        form: {
          name: null,
          type: [],
          content: [],
          note: null
        },
        rules: {
          name: [
            {
              required: true,
              message: '请填写公式名称'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择收费类型'
            }
          ],
          content: [
            {
              required: true,
              message: '请填写配置公式'
            }
          ],
          note: [
            {
              required: true,
              message: '请填写备注'
            }
          ]
        },
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initType().then(() => {
            this.initPage();
          });
        },
        immediate: true
      }
    },
    methods: {
      deleteContent(index) {
        this.form.content.splice(index, 1);
      },
      addContent(data) {
        this.form.content.push({...data});
        if (data.type === 'input') {
          data.value = null;
        }
      },
      initPage() {
        if (this.id) {
          FormulaService.info(this.id).then(res => {
            this.isDefault = !!res.is_default;
            this.form.name = res.name;
            this.form.type = res.expenses_type_id;
            let content = [];
            this.formulaOptions.forEach(val => {
              let reg = new RegExp(val.type === 'input' ? '[0-9]{1,}[.]{0,1}[0-9]' : `${val.type ? '\\' : ''}${val.value}`, 'g');
              [...res.content.matchAll(reg)].map(value => {
                content.push({
                  ...val,
                  value: value[0],
                  position: value.index
                });
              });
            });
            this.form.content = content.sort((a, b) => a.position - b.position).map(val => {
              let obj = {
                value: val.value
              }
              if (val.type) {
                obj.type = val.type;
              } else {
                obj.name = val.name;
              }
              return obj;
            });
            this.form.note = res.remark;
          }).catch(err => {});
        }
      },
      initType() {
        return ChargeTypeService.list().then(res => {
          this.typeOptions = res;
        }).catch(err => {});
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            FormulaService.edit(
              this.id,
              this.form.name,
              this.form.type,
              this.form.content.map(val => val.name ? `[${val.value}]` : val.value).join(''),
              this.form.note
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            FormulaService.add(
              this.form.name,
              this.form.type,
              this.form.content.map(val => val.name ? `[${val.value}]` : val.value).join(''),
              this.form.note
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push({
          name: 'FormulaManage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .wrap {
    border: 1px solid @border-color-base;
    .top {
      background-color: @background-color-base;
      padding: 0 @padding-sm;
      .ant-row-flex {
        .ant-col {
          cursor: pointer;
          &:hover {
            color: @primary-color;
          }
        }
      }
    }
    .bottom {
      padding: @padding-sm;
      min-height: 64px;
    }
  }
</style>